module.exports = __webpack_public_path__ + "static/img/smartstation51.9fad1249.png";